import {
    MDBBtn,
    MDBCol,
    MDBIcon,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalHeader,
    MDBModalTitle,
    MDBRow,
} from "mdbreact"
import {Button, Toolbar, ToolbarItem, ToolbarSpacer} from "@progress/kendo-react-buttons"
import React, {useCallback, useEffect, useRef, useState} from "react"
import {useAppDispatch, useAppSelector} from "../../store"
import {RootState} from "../../rootReducer"
import {Switch} from "@progress/kendo-react-inputs"
import {Field, Form, FormElement} from "@progress/kendo-react-form"
import {
    createSchedule,
    deleteSchedule,
    setSelectedSlot,
    setShowAddEditPopUp,
    updateSchedule,
} from "../../containers/DVSASchedules/schedulesSlice"
import StartDateComponent from "./controls/StartDateComponent"
import TimeComponent from "./controls/TimePicker"
import WeekDaysComponent, {allWeekDays} from "./controls/WeekDaysComponent"
import EndOnDateComponent from "./controls/EndOnComponent"
import SchedulerOccurrences from "./ScheduleOccurrences"
import dayjs from "dayjs"
import {SpinnerFragment} from "../../shared/CommonItems"

const AddEditSchedulesDialog = () => {
    const dispatch = useAppDispatch()
    const loader = useAppSelector((state: RootState) => state.containers.schedules.showDialogLoader)
    const selectedSlot = useAppSelector((state: RootState) => state.containers.schedules.selectedSlot)
    const selectedDealer = useAppSelector((state: RootState) => state.application.selectedSingleDealer)
    const showPopUp = useAppSelector((state: RootState) => state.containers.schedules.showAddEditPopUp)
    const adminId = useAppSelector((state: RootState) => state.application.userInfo.localAccountId)

    const [startDate, setStartDate] = useState<Date>(dayjs().hour(6).toDate())
    const [endDate, setEndDate] = useState<Date>(dayjs().hour(22).minute(0).toDate())

    const [breakStartDate, setBreakStartDate] = useState<Date>(dayjs().hour(6).toDate())
    const [breakEndDate, setbreakEndDate] = useState<Date>(dayjs().hour(22).minute(0).toDate())

    const [repeatDays, setRepeatDays] = useState<string[]>([])

    const [endOnDate, setEndOnDate] = useState<Date | null>(null)
    const [repeatOccurrence, setRepeatOccurrence] = useState<boolean>(false)
    const [applyAllOccurrences, setApplyAllOccurrences] = useState<boolean>(false)
    const [isRecurringEvent, setIsRecurringEvent] = useState<boolean>(false)

    const [isEditMode, setIsEditMode] = useState<boolean>(false)

    const formRef = useRef(null)
    const dateFormat = "YYYY-MM-DDTHH:mm"
    const formData = {
        startDate,
        endDate,
        breakStart: breakStartDate,
        breakEnd: breakEndDate,
        // repeat: repeatOccurrence,
        repeatOn: null,
        endOnDate,
    }

    useEffect(() => {
        if (showPopUp && selectedSlot) {
            if (selectedSlot.id === null) {
                const defStartTime = dayjs(selectedSlot.start).hour(8).minute(0).second(0).toDate()
                const defEndTime = dayjs(selectedSlot.end).hour(15).minute(30).second(0).toDate()
                const breakStart = dayjs(selectedSlot.start).hour(12).toDate()
                const breakEnd = dayjs(selectedSlot.end).hour(12).minute(30).toDate()
                setStartDate(defStartTime)
                setEndDate(defEndTime)
                setBreakStartDate(breakStart)
                setbreakEndDate(breakEnd)
            } else {
                setStartDate(dayjs(selectedSlot.start).toDate())
                setEndDate(dayjs(selectedSlot.end).toDate())
            }
            if (selectedSlot.id) {
                setIsEditMode(true)
            }
            if (selectedSlot.recurrendeId) {
                setIsRecurringEvent(true)
            }
        }
        return () => {
            setStartDate(dayjs().toDate())
            setEndDate(dayjs().toDate())
            setRepeatDays([])
            setEndOnDate(null)

            setRepeatOccurrence(false)
            setApplyAllOccurrences(false)
            setIsEditMode(false)
            setIsRecurringEvent(false)
        }
    }, [selectedSlot, showPopUp])

    const updateStartDate = useCallback(
        (e: any) => {
            const startHour = startDate?.getHours()
            const startMin = startDate?.getMinutes()

            const endHour = endDate?.getHours()
            const endMin = endDate?.getMinutes()

            const newStartDate = dayjs(e.value)
                .hour(startHour ?? 0)
                .minute(startMin ?? 0)
                .toDate()
            const newEndDate = dayjs(e.value)
                .hour(endHour ?? 0)
                .minute(endMin ?? 0)
                .toDate()

            setStartDate(newStartDate)
            setEndDate(newEndDate)
        },
        [endDate, startDate],
    )

    const updateStartDateTime = useCallback((value: any) => {
        setStartDate(new Date(value))
    }, [])

    const updateEndDateTime = useCallback((value: any) => {
        setEndDate(new Date(value))
    }, [])

    const updateBreakStartTime = useCallback((value: any) => {
        setBreakStartDate(new Date(value))
    }, [])

    const updateBreakEndTime = useCallback((value: any) => {
        setbreakEndDate(new Date(value))
    }, [])

    const handleRepeatDays = (day: string) => {
        let selectedDays = repeatDays
        if (repeatDays.some(i => i === day)) {
            selectedDays = repeatDays.filter(i => i !== day)
        } else {
            selectedDays.push(day)
        }
        setRepeatDays([...selectedDays])
        // setEndOnDate(dayjs().toDate())
    }

    const updateLastDate = useCallback((e: any) => {
        setEndOnDate(e.target.value)
    }, [])

    const SwitchComponent = () => {
        return (
            <Switch
                className="me-3"
                onChange={() => {
                    if (!repeatOccurrence && repeatDays.length === 0) {
                        const weekDay = allWeekDays[startDate.getDay()]
                        repeatDays.push(weekDay.value)
                        setRepeatDays(repeatDays)
                    }
                    setRepeatOccurrence(!repeatOccurrence)
                }}
                checked={repeatOccurrence}
            />
        )
    }

    const ApplyToAllOccurrencesComponent = () => {
        return (
            <Switch
                onChange={() => {
                    setApplyAllOccurrences(!applyAllOccurrences)
                }}
                checked={applyAllOccurrences}
            />
        )
    }

    const handleSubmit = (e: any) => {
        const {startDate:taskStartDate, endDate:taskEndDate, breakStart, breakEnd} = e
       
        // API Call
        if (selectedSlot?.id) {
            let recRule = null
            if (selectedSlot.recurrendeId !== null) {
                recRule = selectedSlot.recurrendeId
            }
            if(selectedDealer){
                dispatch(
                    updateSchedule(selectedDealer.dealerId.toString(), {
                        dvsaAvailabilityID: selectedSlot.id.toString(),
                        startDateTime: dayjs(taskStartDate).format(dateFormat),
                        endDateTime: dayjs(taskEndDate).format(dateFormat),
                        recurringGroup: applyAllOccurrences ? recRule : null,
                        updatedByAppUserId: adminId,
                        eventType: selectedSlot.recType,
                    }),
                )
            }
        } else {
            const repeatOn = repeatDays.join(",")
            if(selectedDealer){
                dispatch(
                    createSchedule(selectedDealer.dealerId.toString(), {
                        startDateTime: dayjs(taskStartDate).format(dateFormat),
                        endDateTime: dayjs(taskEndDate).format(dateFormat),
                        breakStartDateTime: dayjs(breakStart).format(dateFormat),
                        breakEndDateTime: dayjs(breakEnd).format(dateFormat),
                        weekDays: repeatOn,
                        lastDate:
                            repeatOccurrence && repeatDays.length > 0
                                ? dayjs(endOnDate).endOf("day").format(dateFormat)
                                : dayjs(taskEndDate).endOf("day").format(dateFormat),
                        UpdatedByAppUserID: adminId,
                        title: "",
                        description: "",
                    }),
                )
            }
        }
    }

    const handleDelete = () => {
        if (selectedSlot?.id) {
            let recRule = null
            if (selectedSlot.recurrendeId !== null) {
                recRule = selectedSlot.recurrendeId
            }
            if(selectedDealer){
            dispatch(
                deleteSchedule(selectedDealer.dealerId.toString(), {
                    dvsaAvailabilityID: selectedSlot.id.toString(),
                    recurringGroup: applyAllOccurrences ? recRule : null,
                    startDate: dayjs(selectedSlot.start).format(dateFormat),
                    endDate: dayjs(selectedSlot.end).format(dateFormat),
                    eventType: selectedSlot.recType,
                }),
            )}
        }
    }

    const renderToolbar = () => (
        <Toolbar className="shadow-0 border-bottom p-0 pb-1 pt-1 ps-1 position-sticky top-0">
            <ToolbarItem>
                <Button
                    type="submit"
                    id="btnSaveSchedules"
                    fillMode="flat"
                    themeColor={"primary"}
                    iconClass="fa fa-save"
                >
                    Save
                </Button>
            </ToolbarItem>

            <ToolbarItem>
                <Button
                    type="submit"
                    id="btnDeleteSchedules"
                    fillMode="flat"
                    themeColor={"primary"}
                    iconClass="fa fa-trash"
                    title="Delete"
                    tabIndex={-1}
                    hidden={!isEditMode || selectedSlot?.recType === "BR"}
                    disabled={selectedSlot !== null && selectedSlot?.conflicts > 1 && !applyAllOccurrences}
                >
                    Delete
                </Button>
            </ToolbarItem>
            <ToolbarSpacer />
            <ToolbarItem>
                {selectedSlot !== null && selectedSlot?.conflicts > 1 && !applyAllOccurrences && (
                    <span>
                        <MDBIcon
                            className="me-1"
                            fas
                            icon="exclamation-triangle"
                            size="default"
                            color="danger"
                        />
                        Bookings already taken, cannot delete
                    </span>
                )}
            </ToolbarItem>
        </Toolbar>
    )

    const renderTimeFieldsBR = () => (
        <>
         {selectedSlot?.id && selectedSlot?.recType === "BR" && (
                <>
                    <MDBCol lg="2" md="4">
                        <Field
                            required
                            value={startDate}
                            tabIndex={2}
                            name="startDate"
                            component={TimeComponent}
                            label="Break Start"
                            updateTime={updateStartDateTime}
                            min={selectedSlot?.minTestStartDate}
                            max={endDate}
                        />
                    </MDBCol>
                    <MDBCol lg="2" md="4">
                        <Field
                            required
                            value={endDate}
                            tabIndex={3}
                            name="endDate"
                            component={TimeComponent}
                            label="Break End"
                            min={startDate}
                            max={selectedSlot?.maxTestEndDate}
                            updateTime={updateEndDateTime}
                        />
                    </MDBCol>
                </>
            )}
        </>
    )
    const renderTimeFieldsSCH = () => (
        <>
        {selectedSlot?.id && selectedSlot?.recType === "SCH" && (
                <>
                    <MDBCol lg="2" md="4">
                        <Field
                            required
                            value={startDate}
                            tabIndex={2}
                            name="startDate"
                            component={TimeComponent}
                            label="Start Time"
                            updateTime={updateStartDateTime}
                            min={dayjs(startDate).startOf("day").add(6, "hour").toDate()}
                            max={
                                !applyAllOccurrences
                                    ? selectedSlot.minTestStartDate ?? undefined
                                    : startDate
                            }
                        />
                    </MDBCol>
                    <MDBCol lg="2" md="4">
                        <Field
                            required
                            value={endDate}
                            tabIndex={3}
                            name="endDate"
                            component={TimeComponent}
                            label="End Time"
                            min={
                                !applyAllOccurrences
                                    ? selectedSlot.maxTestEndDate ?? undefined
                                    : startDate
                            }
                            max={dayjs(endDate).startOf("day").add(22, "hour").toDate()}
                            updateTime={updateEndDateTime}
                        />
                    </MDBCol>
                </>
            )}
        </>
    )
    const renderTimeFields = () => (
        <MDBRow className="mt-2">
            <MDBCol md="4">
                <Field
                    disabled
                    value={startDate}
                    tabIndex={1}
                    name="startDate"
                    component={StartDateComponent}
                    label="Date"
                    onChange={event => {
                        if (event.nativeEvent.target.tagName !== "INPUT") {
                            updateStartDate(event)
                        }
                    }}
                    updateDate={updateStartDate}
                />
            </MDBCol>
            {selectedSlot?.id == null && selectedSlot?.recType === "" && (
                <>
                    <MDBCol lg="2" md="4">
                        <Field
                            required
                            value={startDate}
                            tabIndex={2}
                            name="startDate"
                            component={TimeComponent}
                            label="Start Time"
                            updateTime={updateStartDateTime}
                            min={dayjs(startDate).startOf("day").add(6, "hour").toDate()}
                            max={breakStartDate}
                        />
                    </MDBCol>
                    <MDBCol lg="2" md="4">
                        <Field
                            required
                            value={endDate}
                            tabIndex={3}
                            name="endDate"
                            component={TimeComponent}
                            label="End Time"
                            updateTime={updateEndDateTime}
                            min={breakEndDate}
                            max={dayjs(startDate).startOf("day").add(22, "hour").toDate()}
                        />
                    </MDBCol>
                </>
            )}
            <MDBCol md="4" className="d-block d-sm-block d-md-none"></MDBCol>
            {selectedSlot?.id == null && selectedSlot?.recType === "" && (
                <>
                    <MDBCol lg="2" md="4">
                        <Field
                            required
                            value={breakStartDate}
                            name="breakStart"
                            component={TimeComponent}
                            label="Break Start"
                            updateTime={updateBreakStartTime}
                            min={startDate}
                            max={breakEndDate}
                        />
                    </MDBCol>
                    <MDBCol lg="2" md="4">
                        <Field
                            required
                            value={breakEndDate}
                            name="breakEnd"
                            component={TimeComponent}
                            label="Break End"
                            updateTime={updateBreakEndTime}
                            min={breakStartDate}
                            max={endDate}
                        />
                    </MDBCol>
                </>
            )}

            {renderTimeFieldsSCH()}

            {renderTimeFieldsBR()}
        </MDBRow>
    )
    const renderRecurringContentSchedulerOccurrences = () => (
        <>
         {isEditMode && applyAllOccurrences && selectedDealer && selectedSlot && selectedSlot.recurrendeId && (
                <MDBRow className="mt-2">
                    <MDBCol>
                        <SchedulerOccurrences
                            startDate={dayjs(selectedSlot.start).toDate()}
                            dealerId={selectedDealer.dealerId.toString()}
                            eventType={selectedSlot.recType}
                            recurringGroup={selectedSlot.recurrendeId}
                            scheduleStart={dayjs(formData.startDate).toDate()}
                            scheduleEnd={dayjs(formData.endDate).toDate()}
                        />
                    </MDBCol>
                </MDBRow>
            )}
        </>
    )
    const renderRecurringContent = () => (
        <>
            {isRecurringEvent && (
                <MDBRow className="d-flex align-items-baseline mt-2">
                    <MDBCol md="auto" className="text-center">
                        <Field name="applyOccurrences" component={ApplyToAllOccurrencesComponent} />
                    </MDBCol>
                    <MDBCol auto>
                        <p className="note note-primary">
                            <span>
                                Apply to all future occurrences. If delete is performed,
                                corresponding break record will be deleted.
                            </span>
                        </p>
                    </MDBCol>
                </MDBRow>
            )}
            {renderRecurringContentSchedulerOccurrences()}
            {!isEditMode && (
                <MDBRow className="d-flex align-items-baseline mt-2">
                    <MDBCol md="1" className="text-center">
                        <Field name="repeat" component={SwitchComponent} />
                    </MDBCol>
                    <MDBCol auto>
                        <p className="note note-primary">
                            <span>
                                You can repeat the schedule for every selected week day
                                till the Last Date.
                            </span>
                        </p>
                    </MDBCol>
                </MDBRow>
            )}
            {!isEditMode && repeatOccurrence && (
                <>
                    <hr className="mt-1 mb-1" />
                    <MDBRow className="mt-2">
                        <MDBCol md="4">Every</MDBCol>
                    </MDBRow>
                    <MDBRow>
                        <MDBCol md="2">
                            <WeekDaysComponent
                                repeatDays={repeatDays}
                                handleRepeatDays={handleRepeatDays}
                                startDate={startDate}
                            />
                        </MDBCol>
                    </MDBRow>
                    <MDBRow className="mt-3">
                        <MDBCol md="4">
                            <Field
                                name="endOnDate"
                                value={endOnDate}
                                component={EndOnDateComponent}
                                label={"Last Date"}
                                min={startDate ?? new Date()}
                                required={repeatOccurrence}
                                onChange={event => {
                                    updateLastDate(event)
                                }}
                            />
                        </MDBCol>
                    </MDBRow>
                </>
            )}
        </>
    )

    const renderFormContent = () => {
        return (
            <FormElement className="w-100">
                {renderToolbar()}
                <MDBModalBody className="modal-overflow">
                    <fieldset className={"k-form-fieldset mt-0"}>
                        {renderTimeFields()}
                        {renderRecurringContent()}
                    </fieldset>
                </MDBModalBody>
            </FormElement>
        )
    }

    return (
        <MDBModal staticBackdrop animationDirection="right" show={showPopUp} tabIndex="-1">
            <MDBModalDialog position="top right modal-lg" side>
                <MDBModalContent className="full-height ">
                    <MDBModalHeader>
                        {selectedDealer && selectedSlot && selectedSlot?.recType !== "BR" && (
                            <MDBModalTitle>DVSA Schedules for {selectedDealer.dealerName}</MDBModalTitle>
                        )}
                        {selectedDealer && selectedSlot && selectedSlot?.recType === "BR" && (
                            <MDBModalTitle>Breaks for {selectedDealer.dealerName}</MDBModalTitle>
                        )}
                        <MDBBtn
                            color="none"
                            className="btn-close"
                            onClick={() => {
                                dispatch(setSelectedSlot(null))
                                dispatch(setShowAddEditPopUp(false))
                            }}
                        ></MDBBtn>
                    </MDBModalHeader>
                    {loader && <SpinnerFragment />}
                    {startDate && endDate && (
                        <Form
                            key={JSON.stringify(formData)}
                            onSubmit={(values, event: any) => {
                                event?.preventDefault()
                                if (event.nativeEvent.submitter.id === "btnSaveSchedules") {
                                    handleSubmit(values)
                                }
                                if (event.nativeEvent.submitter.id === "btnDeleteSchedules") {
                                    handleDelete()
                                }
                                return false
                            }}
                            initialValues={formData}
                            ignoreModified
                            ref={formRef}
                            render={renderFormContent}
                        />
                    )}
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    )
}
export default AddEditSchedulesDialog
